export default {
  projectStatus: {
    // A- / V- flow statuses
    created: 'Erstellt',
    ordered: 'Bestellt',
    confirmed: 'Bestätigt',
    planned: 'Geplant',
    is_being_packed: 'Wird gepackt',
    packaged: 'Gepackt',
    setup: 'Aufgebaut',
    dismantled: 'Abgebaut',
    shipped: 'Versendet',
    retourned: 'Retouniert',
    stored: 'Eingelagert',
    completed: 'Abgeschlossen',
    // Generic project lifecycle statuses
    inquiry: 'Anfrage',
    quote: 'Angebot',
    in_progress: 'In Bearbeitung',
    post_calculation: 'Nachkalkulation',
    lost: 'Projekt verloren',
    cancelled: 'Storno',
    ongoing: 'Dauerleistung',
    internal: 'Interne Projekte',
    // Legacy value kept for older records
    draft: 'Entwurf',
  },
}
